import React, { Component } from 'react';
import Title from 'components/TitleWithIcon';
import Footer from 'pages/Home/Footer2'
import {connect } from "react-redux";
import NotAuthorized from 'commons/NotAuthorized';
import AccountCircle from '@material-ui/icons/AccountCircle'
import mapStateToProps from './mapStateToProps';
import LoadingIndicator  from 'commons/LoadingIndicator';
import mapDispatchToProps from './mapDispatchToProps';
import FormularioCambiarContraseña from './Form'

class UserProfile extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'user',
            loading: false,
            authorized:true,
            checkAutorization:false,
            create:false,
            update:false,
            delete:false,
            rowData: [],
            data: [],
            currentUser: props.currentUser,
        }
        this.addRegister = this.addRegister.bind(this);
    }

    async addRegister(){ this.setState({create:true}); }
    
    componentDidMount() {
    }
    render() {
        if (this.state.checkAutorization ) return <LoadingIndicator/>
        if (!this.state.authorized &&  !this.state.loading){ return <NotAuthorized/>}
         
        return (
            <div style={{backgroundColor:"#ededed"}}>
                {this.state.loading ? <LoadingIndicator/> : '' }
                <Title title="Perfil del Usuario" icon={"/assets/PerfilUsuario.png"}/>
                <FormularioCambiarContraseña />
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);